module.exports = __webpack_public_path__ + "static/media/image_login.d0346688.JPG";